export function initWorkspaceProtocolForms() {
  // hide/show add parts fields in new inventory form
  $("#inventory_inventory_type").on('change', function(e){
    if ($(this).val() == "Drug") {
      $("#add-parts-fields").show();
      $("#inventory-temperature-requirements").show();
    } else {
      $("#add-parts-fields").hide();
      $("#inventory-temperature-requirements").hide();
    }
  });

  // hide/show add parts fields in new inventory template form
  $("#inventory_template_inventory_type").on('change', function(e){
    if ($(this).val() == "Drug") {
      $("#add-parts-fields").show();
    } else {
      $("#add-parts-fields").hide();
    }
  });

  $("#has-parts-box").on('change', function(e){
    if ($(this).prop('checked')) {
      $("#parts-details-fields").show();
      $("#part-name-field").attr('disabled', false);
      $("#part-name-field").attr('required', true);
      $("#part-quantity-field").attr('disabled', false);
      $("#part-quantity-field").attr('required', true);
    } else {
      $("#parts-details-fields").hide();
      $("#part-name-field").attr('disabled', true);
      $("#part-name-field").attr('required', false);
      $("#part-quantity-field").attr('disabled', true);
      $("#part-quantity-field").attr('required', false);
    }
  });

  $("#has-no-parts-box").on('change', function(e){
    if ($(this).prop('checked')) {
      $("#parts-details-fields").hide();
      $("#part-name-field").attr('disabled', true);
      $("#part-name-field").attr('required', false);
      $("#part-quantity-field").attr('disabled', true);
      $("#part-quantity-field").attr('required', false);
    } else {
      $("#parts-details-fields").show();
      $("#part-name-field").attr('disabled', false);
      $("#part-name-field").attr('required', true);
      $("#part-quantity-field").attr('disabled', false);
      $("#part-quantity-field").attr('required', true);
    }
  });

  // ---------------------------------------------------------------------------

  function setProtocolClinicalTrialAttributeFieldsVisibility(workspace_type) {
    if (workspace_type == "Clinical Trial") {
      $("#protocol-clinical-trial-attribute-fields").show();
      $("#protocol-clinical-trial-attribute-fields #protocol_name").prop(
        "disabled",
        false
      );

      $("#protocol-supplies-attribute-fields").hide();
      $("#protocol-supplies-attribute-fields #protocol_name").prop(
        "disabled",
        true
      );
    } else {
      $("#protocol-supplies-attribute-fields").show();
      $("#protocol-supplies-attribute-fields #protocol_name").prop(
        "disabled",
        false
      );

      $("#protocol-clinical-trial-attribute-fields").hide();
      $("#protocol-clinical-trial-attribute-fields #protocol_name").prop(
        "disabled",
        true
      );
    }
  }

  // Called when form is loaded to make sure workspace clinical trial attributes are shown for render 'new' after failed create
  setProtocolClinicalTrialAttributeFieldsVisibility(
    $("#protocol_workspace_type").val()
  );

  $("#protocol_workspace_type").change(function () {
    setProtocolClinicalTrialAttributeFieldsVisibility($(this).val());
  });

  // ---------------------------------------------------------------------------

  // Don't show email field when self_admin checked
  $("#self-admin-checkbox").on("change", ":checkbox", function () {
    $("#site-admin-email").toggle();
  });

  // ---------------------------------------------------------------------------

  $(".pharmacy-address-checkbox").on("change", ":checkbox", function () {
    $(".pharmacy-address-fields").toggle();
  });

  // ---------------------------------------------------------------------------

  $("#workspace_shipping_contact_user_id").change(function () {
    var selected = $(this).val();
    if (selected == "") {
      $("#workspace_override_default_shipping_address_fields").show();
      $("#workspace_override_default_shipping_address_fields").prop("disabled", false);
      $("#workspace_address_attributes_country").prop("disabled", false);
      $('.selectpicker').selectpicker('refresh');
    } else {
      $("#workspace_override_default_shipping_address_fields").prop("disabled", true);
      $("#workspace_address_attributes_country").prop("disabled", true);
      $("#workspace_override_default_shipping_address_fields").hide();
      $('.selectpicker').selectpicker('refresh');
    }
  });

  $("#workspace_pharmacy_shipping_contact_user_id").change(function () {
    var selected = $(this).val();
    if (selected == "") {
      $("#workspace_override_pharmacy_shipping_address_fields").show();
      $("#workspace_override_pharmacy_shipping_address_fields").prop("disabled", false);
      $("#workspace_pharmacy_address_attributes_country").prop("disabled", false);
      $('.selectpicker').selectpicker('refresh');
    } else {
      $("#workspace_override_pharmacy_shipping_address_fields").hide();
      $("#workspace_override_pharmacy_shipping_address_fields").prop("disabled", true);
      $("#workspace_pharmacy_address_attributes_country").prop("disabled", true);
      $('.selectpicker').selectpicker('refresh');
    }
  });

  // ---------------------------------------------------------------------------

  // New Requisition Schema File Format
  if ($("#requisition_file_uploader").val() == "Fisher CSV") {
    $("#requisition_schema_file_attributes").hide();

  } else if ($("#requisition_file_uploader").val() == "PDF") {
    $("#requisition_schema_file_attributes").show();

  }

  $("#requisition_file_uploader").change(function () {
    const selected = $(this).val();
    if (selected == "Fisher CSV") {
      $("#requisition_schema_file_attributes").hide();

    } else if (selected == "PDF") {
      $("#requisition_schema_file_attributes").show();

    }
  });
}
